import { useQuery } from '@tanstack/react-query';
import type { MonthlyMenuItem } from '../../models/payments/monthly-menu/monthly-menu-item.model';
import apiRequest from '../../services/apiWrapper';
import { FOOD_PAYMENTS } from '../../utils/constants/urlConstants';

// gets the monthly menu for the student for a given year
async function getMonthlyMenuByStudent(studentId: string, startYear: number) {
  const response = await apiRequest.get<MonthlyMenuItem[]>(
    `${FOOD_PAYMENTS}/students/${studentId}/history`,
    { params: { startYear } }
  );

  return response.data;
}

export function useGetMonthlyMenuByStudent(
  studentId: string,
  startYear: number
) {
  return useQuery({
    queryKey: ['monthly-menu-items', studentId, startYear],
    queryFn: () => getMonthlyMenuByStudent(studentId, startYear),
    enabled: Boolean(studentId && startYear > 0),
    staleTime: 2 * 60 * 1000,
  });
}
